var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "rgb(255, 255, 255)"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 14,
    width: 4,
    ry: 3.36,
    rx: 2,
    y: 23,
    x: 48
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.9285714285714286s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(25.714285714285715 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 14,
    width: 4,
    ry: 3.36,
    rx: 2,
    y: 23,
    x: 48
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.8571428571428571s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(51.42857142857143 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 14,
    width: 4,
    ry: 3.36,
    rx: 2,
    y: 23,
    x: 48
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.7857142857142857s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(77.14285714285714 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 14,
    width: 4,
    ry: 3.36,
    rx: 2,
    y: 23,
    x: 48
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.7142857142857143s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(102.85714285714286 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 14,
    width: 4,
    ry: 3.36,
    rx: 2,
    y: 23,
    x: 48
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.6428571428571429s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(128.57142857142858 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 14,
    width: 4,
    ry: 3.36,
    rx: 2,
    y: 23,
    x: 48
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.5714285714285714s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(154.28571428571428 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 14,
    width: 4,
    ry: 3.36,
    rx: 2,
    y: 23,
    x: 48
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.5s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 14,
    width: 4,
    ry: 3.36,
    rx: 2,
    y: 23,
    x: 48
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.42857142857142855s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(205.71428571428572 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 14,
    width: 4,
    ry: 3.36,
    rx: 2,
    y: 23,
    x: 48
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.35714285714285715s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(231.42857142857142 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 14,
    width: 4,
    ry: 3.36,
    rx: 2,
    y: 23,
    x: 48
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.2857142857142857s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(257.14285714285717 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 14,
    width: 4,
    ry: 3.36,
    rx: 2,
    y: 23,
    x: 48
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.21428571428571427s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(282.85714285714283 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 14,
    width: 4,
    ry: 3.36,
    rx: 2,
    y: 23,
    x: 48
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.14285714285714285s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(308.57142857142856 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 14,
    width: 4,
    ry: 3.36,
    rx: 2,
    y: 23,
    x: 48
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.07142857142857142s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(334.2857142857143 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    height: 14,
    width: 4,
    ry: 3.36,
    rx: 2,
    y: 23,
    x: 48
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "0s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.d54d0b25ac02e50e876be5c3f4e167f8.svg";
export { ForwardRef as ReactComponent };